module.exports = __webpack_public_path__ + "media/images/flags/ic-d1cf8335f1c130c18255ab3173e0d786.svg";